export class Logger {
  private readonly prefix: string;

  constructor(prefix: string) {
    this.prefix = prefix;
  }

  log(...args: any[]) {
    console.log(...args);
    // TODO: show in UI
  }

  debug(...args: any[]) {
    console.debug(this.prefix, ...args);
  }

  wtf(msg: string, e?: Error) {
    let text = msg;
    if (e) text += ` (${e})`;
    console.error(text, e);
    // TODO: show in UI
  }
}
